/**
 * stripe-checkout-redirect.js
 *
 * Intercepte le bouton "Commander" du panier Shopify (thème Dawn),
 * récupère le pays du client depuis le sélecteur de marché Shopify,
 * et redirige vers une session Stripe Checkout avec les frais de
 * livraison calculés automatiquement selon la zone correspondante.
 */
 
(function () {
  const CHECKOUT_FUNCTION_URL =
    'https://bohemia-stripe-checkout.netlify.app/.netlify/functions/create-checkout-session';
 
  const CHECKOUT_BUTTON_SELECTORS = [
    'button[name="checkout"]',
    '.cart__checkout-button',
  ];
 
  // Récupère le code pays ISO depuis le sélecteur de marché Shopify
  // Le thème Dawn expose cette info via Shopify.locale ou le cookie _shopify_country
  function getCountryCode() {
    // Méthode 1 : variable Liquid exposée dans le thème (la plus fiable)
    if (window.Shopify && window.Shopify.country) {
      return window.Shopify.country;
    }
 
    // Méthode 2 : lire le cookie _shopify_country
    const match = document.cookie.match(/(?:^|;\s*)_shopify_country=([^;]*)/);
    if (match) {
      return decodeURIComponent(match[1]);
    }
 
    // Méthode 3 : lire le sélecteur de localisation visible dans le header Dawn
    const localeSelector = document.querySelector(
      '.disclosure__button[aria-expanded] .disclosure__toggle-string, ' +
      'localization-form [name="country_code"]'
    );
    if (localeSelector) {
      return localeSelector.value || localeSelector.textContent.trim();
    }
 
    return null;
  }
 
  function showLoadingState(button) {
    button.disabled = true;
    button.dataset.originalText = button.textContent;
    button.textContent = 'Redirection vers le paiement...';
  }
 
  function resetButtonState(button) {
    button.disabled = false;
    if (button.dataset.originalText) {
      button.textContent = button.dataset.originalText;
    }
  }
 
  async function handleCheckoutClick(event) {
    const button = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
 
    showLoadingState(button);
 
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
 
      if (!cart.items || cart.items.length === 0) {
        alert('Votre panier est vide.');
        resetButtonState(button);
        return;
      }
 
      const items = cart.items.map((item) => ({
        variant_id: item.variant_id,
        quantity: item.quantity,
      }));
 
      const countryCode = getCountryCode();
 
      const response = await fetch(CHECKOUT_FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items,
          cart_token: cart.token,
          country_code: countryCode,
        }),
      });
 
      if (!response.ok) {
        throw new Error('Erreur lors de la création de la session de paiement');
      }
 
      const data = await response.json();
 
      if (data.url) {
        window.location.href = data.url;
      } else {
        throw new Error('Aucune URL de paiement reçue');
      }
    } catch (error) {
      console.error('Erreur checkout Stripe:', error);
      alert(
        "Une erreur est survenue lors de la préparation du paiement. Merci de réessayer."
      );
      resetButtonState(button);
    }
  }
 
  function attachListeners() {
    CHECKOUT_BUTTON_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((button) => {
        if (!button.dataset.stripeCheckoutAttached) {
          button.addEventListener('click', handleCheckoutClick);
          button.dataset.stripeCheckoutAttached = 'true';
        }
      });
    });
  }
 
  document.addEventListener('DOMContentLoaded', attachListeners);
  document.addEventListener('cart:updated', attachListeners);
  document.addEventListener('cart:refresh', attachListeners);
 
  const observer = new MutationObserver(attachListeners);
  document.addEventListener('DOMContentLoaded', () => {
    const cartDrawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
  });
})();